import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import { createStyles, makeStyles, Theme, withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import { ClassNameMap } from '@material-ui/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  }),
);

export interface SimpleDialogProps {
  open: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

type DialogTitleProps = {
  children: React.ReactNode;
  onClose: () => void;
  classes: ClassNameMap<'root' | 'closeButton'>;
};

const DialogTitle = ({ children, onClose, classes }: DialogTitleProps) => (
  <MuiDialogTitle disableTypography className={classes.root}>
    <Typography variant="h6">{children}</Typography>
    {onClose ? (
      <IconButton aria-label="close" onClick={onClose} className={classes.closeButton}>
        <CloseIcon />
      </IconButton>
    ) : null}
  </MuiDialogTitle>
);

const HardwareDialog = (props: SimpleDialogProps) => {
  const classes = useStyles();
  const { onClose, open, children } = props;

  const DialogContent = withStyles((theme: Theme) => ({
    root: {
      padding: theme.spacing(2),
    },
  }))(MuiDialogContent);

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="simple-dialog-title"
      open={open}
      maxWidth="xl"
      fullWidth
    >
      <DialogTitle onClose={onClose} classes={classes}>
        Assign hardware
      </DialogTitle>
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};

export default HardwareDialog;
